<form (ngSubmit)="login()" (keyup.enter)="login()" [formGroup]="loginForm" data-testid="login-form">
  <ion-list>
    <ion-item lines="inset">
      <ion-label color="medium" position="floating">Email address</ion-label>
      <ion-input type="text" formControlName="username" autocomplete="username"></ion-input>
      @if (loginForm.get('username').dirty && loginForm.get('username')?.hasError('required')) {
        <ion-note slot="error">
          Email address is required
        </ion-note>
      }
      @if (loginForm.get('username').dirty && loginForm.get('username')?.hasError('email')) {
        <ion-note slot="error">
          Email address is not a valid email address
        </ion-note>
      }
    </ion-item>
    <ion-item lines="inset">
      <ion-label color="medium" position="floating">Password</ion-label>
      <ion-input type="password" formControlName="password" autocomplete="current-password"></ion-input>
      @if (loginForm.get('password').dirty && loginForm.get('password')?.hasError('required')) {
        <ion-note slot="error">
          Password is required
        </ion-note>
      }
    </ion-item>
  </ion-list>
  <div class="login-button-container" padding-horizontal>
    <ion-button type="submit" [disabled]="loginForm.invalid" color="primary" expand="block">
      Login
    </ion-button>
    @if (!isIos) {
      <ion-button
        routerLink="/create-account/create-user"
        color="primary"
        expand="block"
        class="ion-margin-top"
        data-testid="create-account-button"
        >
        Start a free trial
      </ion-button>
    }
    <ion-item class="forgotten-password">
      <a (click)="showResetPassword()" color="medium">Don't know your password?</a>
    </ion-item>
  </div>
</form>
